import React, { Component } from 'react';
import { flowRight as compose } from 'lodash';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import Loader from '../../../components/Common/Loader/Loader';
import NotFound from '../../../components/NotFound/NotFound';
import AddCategoryForm from '../../../components/SiteAdmin/AddCategoryForm';
import getCategory from './getCategory.graphql';
import messages from '../../../locale/messages';
import { withQuery } from '../../../hoc/withGraphql';
import s from './EditCategory.css';

export class EditCategory extends Component {
    static propTypes = {
        id: PropTypes.number.isRequired
    }
    static defaultProps = {
        data: {
            loading: true
        }
    }
    render() {
        const { data: { loading, getCategory }, data, id } = this.props;
        const { formatMessage } = this.props.intl;

        let initialValues = {};

        if (!loading && getCategory?.status === 200 && getCategory?.result) {
            initialValues = {
                id: getCategory?.result?.id,
                name: getCategory?.result?.name,
                description: getCategory?.result?.description,
                logoImage: getCategory?.result?.logoImage,
                bannerImage: getCategory?.result?.bannerImage,
                isPopular: getCategory?.result?.isPopular,
                isJobPhotoRequired: getCategory?.result?.isJobPhotoRequired,
                travellingPrice: getCategory?.result?.travellingPrice,
                userServiceFeeValue: getCategory?.result?.userServiceFeeValue,
                partnerServiceFeeValue: getCategory?.result?.partnerServiceFeeValue,
                pricingType: getCategory?.result?.pricingType,
                status: getCategory?.result?.status,
                currency: getCategory?.result?.currency,
                icon: getCategory?.result?.icon,
                slug: getCategory?.result?.slug,
                metaTitle: getCategory?.result?.metaTitle,
                metaDescription: getCategory?.result?.metaDescription,
                displayOrder: getCategory?.result?.displayOrder
            }
        }

        if (!loading && !getCategory?.result?.id) {
            return <NotFound title={formatMessage(messages.pageNotFound)} />;
        } else {
            return (
                <Loader type={"page"} show={loading}>
                    {!loading && <AddCategoryForm initialValues={initialValues} />}
                </Loader>
            )
        }
    }
}

export default compose(injectIntl,
    withStyles(s),
    withQuery(getCategory, {
        options: (props) => ({
            variables: {
                id: Number(props.id)
            },
            fetchPolicy: 'network-only',
            ssr: false
        })
    }))(EditCategory);
